/* unplugin-vue-components disabled */import script from "./membership-privilege.vue?vue&type=script&setup=true&lang=js"
export * from "./membership-privilege.vue?vue&type=script&setup=true&lang=js"

import "./membership-privilege.vue?vue&type=style&index=0&id=251cee51&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_do6gl7biqum247ry4qofa4hfiq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251cee51"]])

export default __exports__